<template>
  <div class="user-search-result-item">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'UserSearchResultItem',
  };
</script>

<style scoped lang="scss">
  .user-search-result-item {
    display: flex;
    cursor: pointer;
    flex-direction: row;
    align-items: center;
    height: 64px;
    padding: 0 12px;
    &__checkbox {
      margin-right: 12px;
    }

    &:hover {
      background-color: #f3f6fb;
    }
  }
</style>
